import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { trackWhatsappClick } from "../services/analyticsService";

export default function WhatsappButtonTracked({
  empresaId,
  empresaSlug,
  telefono,
  mensaje = "Hola, quiero mÃ¡s informaciÃ³n",
}) {
  const handleClick = () => {
    const url = `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`;

    trackWhatsappClick({
      empresaId,
      empresaSlug,
    }).catch((error) => {
      console.warn("No se pudo registrar el click de WhatsApp:", error);
    });

    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      onClick={handleClick}
      className="btn btn-success rounded-circle shadow-lg"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "60px",
        height: "60px",
        zIndex: 1100,
      }}
    >
      <FaWhatsapp size={28} />
    </button>
  );
}
